export default __webpack_public_path__ + "static/media/new CI.84133ed8.svg";